import React from 'react';
import {Box, ToggleButton, ToggleButtonGroup} from '@mui/material';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';

import {VIEW_TYPES} from '../../helpers/SessionHelper';

const styles = {
    container: {
        paddingLeft: '0.5rem',
        paddingBottom: '0.4rem'
    },
    toggleButtonGroup: {
        '& .MuiToggleButton-root': {
            padding: '0.25rem 0.5rem',
            minWidth: 'auto'
        }
    },
    viewAgendaIcon: {
        transform: 'rotate(90deg)'
    }
};

export default function MySessionViewToggle({currentView, onViewChange}) {
    const handleViewChange = (event, newView) => {
        if (newView !== null) {
            onViewChange(newView);
        }
    };

    return (
        <Box sx={styles.container}>
            <ToggleButtonGroup
                value={currentView}
                exclusive
                onChange={handleViewChange}
                aria-label="view toggle"
                size="small"
                sx={styles.toggleButtonGroup}>
                <ToggleButton value={VIEW_TYPES.DEFAULT} aria-label="default view">
                    <ViewAgendaIcon
                        color={currentView === VIEW_TYPES.DEFAULT ? "primary" : "inherit"}
                        sx={styles.viewAgendaIcon}/>
                </ToggleButton>
                <ToggleButton value={VIEW_TYPES.GRID} aria-label="grid view">
                    <AutoAwesomeMosaicIcon color={currentView === VIEW_TYPES.GRID ? "primary" : "inherit"}/>
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};